import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Notification from '../../Notifications/Notification';
import SystemNotification from '../../SystemNotification';
import { ResourceType } from '../../types/resource';
import { CoreBadgeType } from '../types';
import BadgeNotificationIcon from './BadgeNotificationIcon';
import s from './BadgeNotification.scss';
var BadgeNotification = function (_a) {
    var _b, _c;
    var id = _a.id, queueName = _a.queueName, badge = _a.badge, recipient = _a.recipient;
    var t = useTranslation().t;
    var transKey;
    switch (recipient.typeId) {
        case ResourceType.DEVIATION:
            transKey = 'coreBadge.awardBadge.success.tooltip.deviation';
            break;
        case ResourceType.COMMENT:
            transKey = 'coreBadge.awardBadge.success.tooltip.comment';
            break;
        default:
            return null;
    }
    var articleKeys = (_b = {},
        _b[CoreBadgeType.GLASS] = 'coreBadge.awardBadge.success.tooltip.article.glass',
        _b[CoreBadgeType.EMERALD] = 'coreBadge.awardBadge.success.tooltip.article.emerald',
        _b[CoreBadgeType.DIAMOND] = 'coreBadge.awardBadge.success.tooltip.article.diamond',
        _b);
    var badgeKeys = (_c = {},
        _c[CoreBadgeType.GLASS] = 'coreBadge.awardBadge.success.tooltip.badge.glass',
        _c[CoreBadgeType.EMERALD] = 'coreBadge.awardBadge.success.tooltip.badge.emerald',
        _c[CoreBadgeType.DIAMOND] = 'coreBadge.awardBadge.success.tooltip.badge.diamond',
        _c);
    return (React.createElement(Notification, { id: id, queueName: queueName, cardComponent: SystemNotification, cardProps: {
            multiLine: true,
            withCloseButton: false,
            className: s['root'],
            customIcon: (React.createElement(BadgeNotificationIcon, { name: badge.name, imgSrc: badge.images[0].imageUrl }))
        } },
        React.createElement("div", { className: s['badge-text'] },
            React.createElement(Trans, { i18nKey: transKey },
                "You've awarded ",
                {
                    article: t(articleKeys[badge.name])
                },
                " ",
                React.createElement("strong", null, {
                    title: t(badgeKeys[badge.name])
                }),
                " to this item!"))));
};
BadgeNotification.displayName = 'BadgeNotification';
export default BadgeNotification;
//# sourceMappingURL=BadgeNotification.js.map